import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OidcSecurityService, AuthenticatedResult, UserDataResult, LoginResponse } from 'angular-auth-oidc-client';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private oidcSecurityService: OidcSecurityService) {}

  public isLoggedIn(): Observable<AuthenticatedResult> {
    return this.oidcSecurityService.isAuthenticated$;
  }

  public idToken(): string {
    return this.oidcSecurityService.getIdToken();
  }

  public accessToken(): string {
    return this.oidcSecurityService.getAccessToken();
  }

  public userData(): Observable<UserDataResult> {
    return this.oidcSecurityService.userData$;
  }

  public checkAuth(): Observable<LoginResponse> {
    return this.oidcSecurityService.checkAuth();
  }

  public login(): void {
    this.oidcSecurityService.authorize();
  }

  public signOut(): void {
    this.oidcSecurityService.logoffAndRevokeTokens();
    this.oidcSecurityService.logoff();
  }
}
